<router-outlet></router-outlet>
<div kendoDialogContainer></div>
<ngx-loading-bar height="4px" color="#f5a600" [includeSpinner]="false"></ngx-loading-bar>
